import React from 'react'
import styles from './Spinner.module.css'

/**
 * Simple loading spinner component
 * Replaces reactjs-simple-spinner dependency
 *
 * @param {string} lineFgColor - Color of the spinner (default: #333)
 * @param {number} size - Size of the spinner in pixels (default: 30)
 */
const Spinner = ({ lineFgColor = '#333', size = 30 }) => {
    const spinnerStyle = {
        width: `${size}px`,
        height: `${size}px`,
        borderColor: lineFgColor,
        borderTopColor: 'transparent',
    }

    return <div className={styles.spinner} style={spinnerStyle} />
}

export default Spinner
